export default {"src":"/_next/static/media/logoNhblack.84b61590.svg","height":58,"width":304};